const $ = jQuery.noConflict();

class Slider {
    constructor(sel, arrows = true, fade = false, num = 1, tabNum = 1, slideSpeed = 600, variableWidth = false, centerMode = false, dots = false, autoplay = false, infiniteScroll = true) {
        this.selector = sel;
        this.arrows = arrows;
        this.num = num;
        this.tabNum = tabNum;
        this.variableWidth = variableWidth;
        this.slideSpeed = slideSpeed;
        this.fade = fade;
        this.centerMode = centerMode;
        this.dots = dots;
        this.autoplay = autoplay;
		this.infiniteScroll = infiniteScroll;
    }

    refresh() {
        $(this.selector).slick('refresh');
    }

    init() {
        const {
            arrows,
            num,
            fade,
            tabNum,
            slideSpeed,
            variableWidth,
            centerMode,
            dots,
            autoplay,
			infiniteScroll
        } = this;

        function slideSettings() {
            // Set max-width to slider captions when variableWidth = true
            $(this).on('setPosition', () => {
                $(this).find('figcaption').each((i, item) => {
                    const caption = $(item);
                    const width = caption.prev('img').width();

                    if (window.matchMedia('screen and (max-width: 991px)').matches ) {
                        caption.css('max-width', width > 0 ? `${width}px` : '');
                    } else {
                        caption.css('max-width', width > 0 ? `${645}px` : '');
                    }
                });
            });
            $(this).slick({
                dots,
                autoplay,
                autoplaySpeed: 5000,
                arrows,
                infinite: infiniteScroll,
                slidesToShow: num,
                centerMode,
                slidesToScroll: 1,
                variableWidth,
                fade,
                pauseOnHover: false,
                speed: slideSpeed,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: tabNum,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: tabNum,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });

            $(this).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                const slide = $( slick.$slides.get(currentSlide) );
                if ( slide.find('iframe').length ) {
                    slide.find('iframe').attr('src', '');
                    slide.find('.iframe-wrapper__overlay').show();
                }
            } )
        }
        $(this.selector).each(slideSettings);
    }
}
const RelatedEventsSlider =  new Slider('.related-events__slider', false, false, 3, 1, 600, false, false, true);
const HeroSlider = new Slider('.page-hero__slider', true, true, 1, 1, 600, false, false, true, true);
const HeroEventsSlider =  new Slider('.events-hero__slider', false, false, 3, 1, 600, false, false, true);
const SimpleSlider = new Slider('.bc-gallery__slider', true, false, 3, 3, 600, true, true);
const LightboxSlider = new Slider('.lightbox-gallery__slider',true, false, 1, 1, 600, true, true, false, false, false);
const HeroNewsSlider = new Slider('.news-hero__slider', false, false, 2, 1, 600, false, false, true);
const FactsSlider = new Slider('.block-facts-collage__slider', false, false, 1, 1, 600, false, false, true);
const UpcomingGamesSlider = new Slider('.block-upcoming-games__mobile', false, false, 1, 1, 600, false, false, true);


if ( $( '.ath-hero__slider' ).length ) {
    $('.ath-hero__slider').slick({
        autoplay: true,
    });
}

if ( $( '.block-news__news-wrapper' ).length ) {
	$( '.block-news__news-wrapper' ).each((index, element) => {
		console.log(element);
		if ( $(element).children('.block-news__news-item').length > 0 ) {
			let number_of_slides_to_show_desktop = 1;
			let number_of_slides_to_scroll_desktop = 1;
			let show_dots_desktop = false;
			let number_of_slides_to_show_tablet = 1;
			let number_of_slides_to_scroll_tablet = 1;
			let show_dots_tablet = false;
			let number_of_slides_to_show_mobile = 1;
			let number_of_slides_to_scroll_mobile = 1;
			let show_dots_mobile = false;
			if ( $(element).children('.block-news__news-item').length >= 3) {
				number_of_slides_to_show_desktop = 3;
				number_of_slides_to_scroll_desktop = 3;
				show_dots_desktop = true;
				number_of_slides_to_show_tablet = 2;
				number_of_slides_to_scroll_tablet = 2;
				show_dots_tablet = true;
				number_of_slides_to_show_mobile = 1;
				number_of_slides_to_scroll_mobile = 1;
				show_dots_mobile = true;
			} else if ( $(element).children('.block-news__news-item').length === 2 ) {
				number_of_slides_to_show_desktop = 2;
				number_of_slides_to_scroll_desktop = 2;
				show_dots_desktop = false;
				number_of_slides_to_show_tablet = 2;
				number_of_slides_to_scroll_tablet = 2;
				show_dots_tablet = false;
				number_of_slides_to_show_mobile = 1;
				number_of_slides_to_scroll_mobile = 1;
				show_dots_mobile = true;
			}
			console.log(number_of_slides_to_show_desktop, show_dots_desktop);
			$(element).slick({
				autoplaySpeed: 10000,
				arrows: false,
				dots: show_dots_desktop,
				infinite: false,
				slidesToShow: number_of_slides_to_show_desktop,
				slidesToScroll: number_of_slides_to_scroll_desktop,
				pauseOnHover: false,
				autoplay: false,
				responsive: [
					{
						breakpoint: 1000,
						settings: {
							dots: show_dots_tablet,
							slidesToShow: number_of_slides_to_show_tablet,
							slidesToScroll: number_of_slides_to_scroll_tablet,
						},
					},
					{
						breakpoint: 600,
						settings: {
							dots: show_dots_mobile,
							slidesToShow: number_of_slides_to_show_mobile,
							infinite: false,
							slidesToScroll: number_of_slides_to_scroll_mobile,
							autoplay: false,
						},
					},
				],
			});
		}
	});
    
    var newsContainer = $('.block-news .container');
    function isElementInViewport (el) {
    
        // Special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
    
        var rect = el.getBoundingClientRect();
    
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }
    
    function onVisibilityChange(el, callback) {
        var old_visible;
        return function () {
            var visible = isElementInViewport(el);
            if (visible != old_visible) {
                old_visible = visible;
                if (typeof callback == 'function') {
                    callback(visible);
                }
            }
        }
    }
    
    var handler = onVisibilityChange($('.block-news__header'), function(visible) {
        if ( visible ) {
            newsContainer.addClass('fadeInUp');
        }
    });
    
    
    // jQuery
    $(window).on('DOMContentLoaded load resize scroll', handler);
}


var setProgressBar = (videoSlider, breakpoint, slideCount, slidesToShow) => {
	console.log( 'progress: ' + breakpoint + ',' + slideCount + ',' + slidesToShow );
    let incrementAmount  = 1 / slideCount * 100;

    if ( null === breakpoint || breakpoint > 1000 ) {
        let progressBarWidth = slidesToShow / slideCount * 100;    
        if ( slideCount > 1 && slideCount !== slidesToShow ) {
            videoSlider.find('.block-video-slider__progress-inner').width( progressBarWidth + '%' );
            videoSlider.find('.block-video-slider__footer').show();
        } else {
            videoSlider.find('.block-video-slider__footer').hide();
        }
    } else if ( breakpoint > 601 ) {
        let responsiveSlidesToShow = slidesToShow > 3 ? 3 : slidesToShow;
        let progressBarWidth = responsiveSlidesToShow / slideCount * 100;
    
        if ( ( slideCount > 1 && slideCount !== slidesToShow ) || ( slideCount === 4 && slidesToShow === 4 ) ) {
            videoSlider.find('.block-video-slider__progress-inner').width( progressBarWidth + '%' );
            videoSlider.find('.block-video-slider__footer').show();
        } else {
            videoSlider.find('.block-video-slider__footer').hide();
        }
    } else {
        let progressBarWidth = 2 / slideCount * 100;
		console.log('width: ' + progressBarWidth);
    
        if ( ( slideCount > 1 && slideCount !== slidesToShow ) || ( slideCount === 3 && slidesToShow === 3 ) || ( slideCount === 4 && slidesToShow === 4 ) ) {
            videoSlider.find('.block-video-slider__progress-inner').width( progressBarWidth + '%' );
            videoSlider.find('.block-video-slider__footer').show();
        } else {
            videoSlider.find('.block-video-slider__footer').hide();
        }
    }
}

$('.block-video-slider').each(function() {
    let videoSlider = $( this );
    if ( videoSlider.length ) {
        let slideCount      = videoSlider.find('.block-video-slider__slide').length
		let maxColumns      = videoSlider.data('slides');
		let slidesToShow    = maxColumns > slideCount ? slideCount : maxColumns;
		let slidesToShowTenHundred = 3;
		let slidesToShowSixHundred = 2;

		if ('2' == slidesToShow) {
			slidesToShowTenHundred = 2;
		}

		if ('1' == slidesToShow) {
			slidesToShowTenHundred = 1;
			slidesToShowSixHundred = 1;
		}

        let startWidth      = window.innerWidth > 0 ? window.innerWidth : screen.width;
        let incrementAmount = 1 / slideCount * 100;
		
        setProgressBar( videoSlider, startWidth, slideCount, slidesToShow );

        videoSlider.find('.block-video-slider__videos').slick({
            arrows: true,
            infinite: false,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            pauseOnHover: false,
            prevArrow: videoSlider.find('.block-video-slider__arrow--prev'),
            nextArrow: videoSlider.find('.block-video-slider__arrow--next'),
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: slidesToShowTenHundred,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: slidesToShowSixHundred,
                    },
                },
            ],
        });

        // Move progress bar.
        videoSlider.on( 'beforeChange', (event, slick, currentSlide, nextSlide) => {
            videoSlider.find('.block-video-slider__progress-inner').css( 'left', incrementAmount * nextSlide + '%' );
        } )

        videoSlider.on( 'breakpoint', (event, slick, breakpoint) => {
            setProgressBar( videoSlider, breakpoint, slideCount, slidesToShow );
        });
    }
});


export { SimpleSlider, LightboxSlider, HeroSlider, HeroNewsSlider, FactsSlider, HeroEventsSlider, UpcomingGamesSlider, RelatedEventsSlider };
